import React from 'react';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { Modal, Card, CardContent, Portal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const MICROSOFT_VIEWER_FILE_TYPES = ['.docx', '.doc', '.xlsx', '.xls', '.ppt', '.pptx', '.odt'];

const checkIfFileIsValidForMicrosoftViewer = fileName => MICROSOFT_VIEWER_FILE_TYPES.some(s => fileName.toLowerCase().endsWith(s));

export function PreviewFileModal({ activeDocument, handleClose }) {
  return <Portal >
    <Modal open={true} onClose={handleClose}>
      <Card sx={{ ...style, width: '100vw', height: '100vh' }}>
        <CardContent sx={{ height: '100%', position: 'relative' }}>
          <IconButton color="primary" onClick={handleClose} sx={{ position: 'absolute', top: '8px', right: '8px', zIndex: 9999 }}>
            <CloseIcon />
          </IconButton>
          {activeDocument.fileName.endsWith('.pdf') || activeDocument.fileName.endsWith('.txt')
            ? <iframe src={activeDocument.uri} border="0" width={'100%'} height={'95%'} style={{ marginTop: '25px' }}></iframe>
            : checkIfFileIsValidForMicrosoftViewer(activeDocument.fileName)
              ? <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(activeDocument.file_url)}`} border="0" width={'100%'} height={'95%'} style={{ marginTop: '25px' }}></iframe>
              : <DocViewer documents={[activeDocument]} pluginRenderers={DocViewerRenderers} activeDocument={activeDocument} />}
        </CardContent>
      </Card>
    </Modal>
  </Portal>;
}
